import { render, staticRenderFns } from "./LeaderBanner.vue?vue&type=template&id=68f24e65&scoped=true"
var script = {}
import style0 from "./LeaderBanner.vue?vue&type=style&index=0&id=68f24e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f24e65",
  null
  
)

export default component.exports